var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20581_77466)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.4,
    stroke: "#E4E4E5",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_20581_77466)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 12,
    fill: "#E4E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9882 9.59961C19.3877 9.59961 19.7115 9.92346 19.7115 10.323V19.3595C19.7115 19.759 19.3877 20.0828 18.9882 20.0828H11.5241C11.1246 20.0828 10.8008 19.759 10.8008 19.3595V10.323C10.8008 9.92346 11.1246 9.59961 11.5241 9.59961H18.9882ZM16.0038 16.8691H12.6177C12.4006 16.8691 12.2246 17.0451 12.2246 17.2622C12.2246 17.4793 12.4006 17.6553 12.6177 17.6553H16.0038C16.2209 17.6553 16.3969 17.4793 16.3969 17.2622C16.3969 17.0451 16.2209 16.8691 16.0038 16.8691ZM17.9069 14.3911H12.6177C12.4006 14.3911 12.2246 14.5671 12.2246 14.7842C12.2246 15.0013 12.4006 15.1773 12.6177 15.1773H17.9069C18.124 15.1773 18.3 15.0013 18.3 14.7842C18.3 14.5671 18.124 14.3911 17.9069 14.3911ZM17.8721 11.9177H12.5829C12.3658 11.9177 12.1898 12.0937 12.1898 12.3108C12.1898 12.5279 12.3658 12.7039 12.5829 12.7039H17.8721C18.0892 12.7039 18.2652 12.5279 18.2652 12.3108C18.2652 12.0937 18.0892 11.9177 17.8721 11.9177Z",
    fill: "#9FA0A7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20581_77466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_20581_77466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.8b8aee1573dc8d896d5b46c0f28bd86b.svg";
export { ForwardRef as ReactComponent };